import * as types from 'misc/types';
import * as actions from 'misc/actions';

const medias = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_MEDIAS_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_MEDIAS_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_MEDIAS_GET.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default medias;



// WEBPACK FOOTER //
// ./src/reducers/medias.js